import {
  REQUEST_CALENDARS, RECEIVE_CALENDARS, RECEIVE_CALENDAR,
} from '../actions/calendar';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_CALENDARS:
      return { ...state, loading: true };
    case RECEIVE_CALENDARS:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_CALENDAR:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
